import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ahrefs = defineConnector({
  identifier: "ahrefs",
  name: "Ahrefs",
  tagLine: "SEO and backlink analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.ahrefs\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Ahrefs](https://app.ahrefs.com/account/api), open **Account settings › API keys** and generate a key. The API requires an Enterprise plan or API add-on.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.ahrefs.com/v3/subscription-info/limits-and-usage",
  },
});
